import { styled as muiStyled } from '@mui/material'

export const FrequencySelectionHeading = muiStyled('h1')(
  ({ theme }) => `
font-size: 16px;
font-weight: 700;
text-align: center;
color: rgb(40, 44, 47);
text-transform: uppercase;
margin-bottom: 2px;
letter-spacing: 1px;
@media (min-width: 768px) {
font-size: 22px;
margin-bottom: 8px;
}
`,
)
